<template>
  <div class="form-group">
     <div class="row">

    <div class="col-form-input" :class="nolabel ? 'col-sm-12' : 'col-sm-' + (12 - labelCol)">
      <div class="form-check-wrapper" :class="{ invalid: !isValid }">
        <div
          ref="options"
          v-for="option in options"
          class="form-check form-check-inline"
          :key="option.Key"
        >
          <label class="form-check-label">
            
            <input
              style="width: 36px; 
            height: 36px; "
              type="checkbox"
              :value="option.Key"
              class="form-check-input-styled"
              @change="dataChanged"
              :disabled="readonly ? true : false"
              v-model="val"
            />
            {{ option.Value }}
          </label>
        </div>
      </div>
      <span v-if="helptext" class="form-text text-muted">{{ helptext }}</span>
    </div>
    <label
      v-if="isValid === false"
      id="basic-error"
      class="validation-invalid-label"
      for="basic"
    >{{ $t('ui.SYS00016') }}</label>
    </div>
  </div>
</template>
<script>
import helper from '../vueHelper';
export default {
  name: "CheckBoxMultiple",
  props: [
    "id",
    "title",
    "value",
    "options",
    "readonly",
    "required",
    "labelwidth",
    "nolabel",
    "helptext",
    "list"
  ],
  data() {
    return {
      d: null,
      isValid: true,
      val: []
    };
  },
  mounted() {
    this.initCheckbox();
    if (this.value) {
      this.val = this.value;
    }
    // $(this.$el).find(':checkbox[value="' + this.value + '"]').prop('checked', true)
  },
  computed: {
    labelCol() {
      return this.labelwidth || 3;
    }
  },
  methods: {
    setFocus() {
      $(this.$el)
        .find(":checkbox")
        .filter(":first")
        .focus();
    },
    setValid(val) {
      this.isValid = val;
    },
    isFieldValid() {
      return (
        !this.required ||
        (this.required &&
          this.val !== null &&
          this.val !== undefined &&
          this.val.length !== 0)
      );
    },
    dataChanged(e) {
      if ($(e.target).is(":checked")) {
        this.d = $(e.target).val();
        if(this.list.length<4){
        this.list.push($(e.target).val());
        }else{
            helper.alert("The Column show select maximum 4");
            this.val=false;
        }
      } else {
        var index = this.list.indexOf($(e.target).val());
        this.list.splice(index, 1);
        this.d = null;
      }
      this.$emit("input", this.val);
    },
    resetValue() {
      this.isValid = true;
      $(this.$el)
        .find(":checkbox")
        .prop("checked", false);
    },
    initCheckbox() {
      // $(this.$refs.options)
      //   .find(".form-check-input-styled")
      //   .uniform({
      //     wrapperClass: "border-success-600 text-success-800"
      //   });
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.val = val;
      }
    }
  }
};
</script>
